import { FETCH_USER_PREFERENCES_SUCCESS, ADD_USER_PREFERENCE, REMOVE_USER_PREFERENCE } from '../constants/ActionTypes';

export default function userPreferences(state = [], action) {
    switch (action.type) {
        case FETCH_USER_PREFERENCES_SUCCESS:
            return action.body.userPreferences || [];

        case ADD_USER_PREFERENCE: {
            const preferences = [...state];
            let changedIndex = preferences.findIndex((prefSet) => prefSet.name === action.payload.id);

            if (changedIndex === -1) {
                preferences.push({ name: action.payload.id, values: [] });
                changedIndex = preferences.length - 1;
            } else {
                preferences[changedIndex] = { ...preferences[changedIndex] };
            }

            action.payload.values.forEach((name) => {
                if (!preferences[changedIndex].values.includes(name)) {
                    preferences[changedIndex].values.push({ name });
                }
            });

            return preferences;
        }

        case REMOVE_USER_PREFERENCE: {
            const preferences = [...state];
            const changedIndex = preferences.findIndex((prefSet) => prefSet.name === action.payload.id);
            preferences[changedIndex] = { ...preferences[changedIndex] };
            preferences[changedIndex].values = preferences[changedIndex].values.filter(({ name }) => !action.payload.values.includes(name));

            return preferences;
        }

        default:
            return state;
    }
}
